import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import CheckboxInput from '../../../Helpers/Inputs/CheckboxInput';
import ButtonInput from '../ButtonInput/ButtonInput';
import ThermometerIcon from '../../../../icons/thermometer.svg?react';
import CarIcon from '../../../../icons/car.svg?react';
import HealthNotesIcon from '../../../../icons/health-notes.svg?react';
import WalletIcon from '../../../../icons/wallet.svg?react';
import SwapABIcon from '../../../../icons/swap-a-b.svg?react';
import MedicalCrossIcon from '../../../../icons/medical-cross.svg?react';
import DisabilityIcon from '../../../../icons/disabled.svg?react';
import BloodPressureIcon from '../../../../icons/blood-pressure.svg?react';
import BackNext from '../../Common/SubComponents/BackNext';

import './PreQuoter.scss';

const buttonData = [
  {
    icon: ThermometerIcon,
    title: 'Hospitalized within the last two years',
  },
  {
    icon: CarIcon,
    title: 'Charged with a felony or DUI within the last five years',
  },
  {
    icon: HealthNotesIcon,
    title: 'History of any serious medical or health condition',
  },
  {
    icon: WalletIcon,
    title: 'Bankruptcy within the last two years',
  },
  {
    icon: SwapABIcon,
    title: 'Replacing an existing life insurance policy',
  },
  {
    icon: MedicalCrossIcon,
    title: 'Taking any prescription medications',
  },
  {
    icon: DisabilityIcon,
    title: 'Disabled or receiving Social Security disability benefits',
  },
  {
    icon: BloodPressureIcon,
    title: 'Treated for high blood pressure or cholesterol',
  }
];

export default function FindCarriers(props) {

  const { register } = useForm({
    mode: 'all',
    reValidateMode: 'all',
  });

  useEffect(() => {
    // control the Checkbox based on if knockouts are selected
    var selected = false;
    props.formState.knockouts.forEach((k) => {
      selected = selected || k
    });

    props.onFieldChange("noneApply", !selected);
  }, [props.formState.knockouts]);

  const handleValueChange = (value, index) => {
    var stateCopy = props.formState.knockouts.slice(0);
    stateCopy[index] = value;
    props.onFieldChange("knockouts", stateCopy);
  };

  const clearValues = () => {
    props.onFieldChange("knockouts", [...Array(buttonData.length).keys()].map((i) => false));
  };

  return (
    <Container>
      <Form className="find-carriers" onSubmit={props.onNext}>
        <Row className="justify-content-center mb-2">
          <h2 className="text-center" >Please select all that apply...</h2>
        </Row>
        <Row className="justify-content-center" role="group" aria-labelledby="Finding the right carriers">
          {buttonData.map((d, index) =>
            <Col xs="auto" key={index} className="d-flex justify-content-center btn-wrapper">
              <ButtonInput
                icon={d.icon}
                title={d.title}
                subtitle=''
                value={props.formState.knockouts[index]}
                onClick={() => handleValueChange(!props.formState.knockouts[index], index)}
              />
            </Col>
          )}
        </Row>
        <Row className="justify-content-center">
          <CheckboxInput
            id="none-apply"
            onChange={clearValues}
            checked={props.formState.noneApply}
            name="none-apply"
            inputRef={register}
            label="None of these apply"
          />
        </Row>
        <Row className="justify-content-center m-5">
          <BackNext onBack={props.onBack} />
        </Row>
      </Form>
    </Container>
  );
}

FindCarriers.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

FindCarriers.DefaultFormState = (prefill = false) => {
  return {
    knockouts: [...Array(buttonData.length).keys()].map((i) => false),
    noneApply: true
  };
};
